import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Block from './components/Block';

import styles from './styles.module.scss';

const StyledContent = ({ blocks, spacing, tagsTheme }) => (
	<div className={cx(styles.content, styles[`spacing_${spacing}`])}>
		{_(blocks).map((block, index) => (
			// eslint-disable-next-line react/no-array-index-key
			<Block key={`${block.type}-${index}`} {...{ ...block, tagsTheme }} />
		))}
	</div>
);

StyledContent.propTypes = {
	blocks: PropTypes.arrayOf(
		PropTypes.shape({ type: PropTypes.string.isRequired }).isRequired
	).isRequired,
	spacing: PropTypes.oneOf(['large']),
	tagsTheme: PropTypes.oneOf(['dark', 'light'])
};

export default StyledContent;
